export enum RateStatus {
  CHECKED_NO_CHANGE = 'CHECKED_NO_CHANGE',
  CHECKED_CHANGE = 'CHECKED_CHANGE',
  UNAVAILABLE = 'UNAVAILABLE',
  NOT_FOUND = 'NOT_FOUND', // This state is created in the frontend
}
